import Card from "@/design-system/Card/Card";

// Same card and height as a loaded PlayerRow, so nothing jumps on load.
const LoadingPlayerCard = () => (
  <Card
    hoverable={false}
    className="h-39 w-full animate-pulse touch-device:h-[143px]"
  >
    {null}
  </Card>
);

const LoadingPlayersList = () => {
  return (
    <div className="flex flex-col gap-y-2">
      {Array.from({ length: 20 }).map((_, index) => (
        <LoadingPlayerCard key={index} />
      ))}
    </div>
  );
};

export default LoadingPlayersList;
